import React, { useState, useEffect } from "react"
import { Button, Card, CardBody, CardText, CardTitle, FormGroup, Label, Modal, ModalBody, ModalHeader, Table } from "reactstrap"

import BreadCrumb from "../Components/BreadCrumb"

import tasks from "../constants/tasks.json"
import { api } from "../apis/usertasks/api"

const Tasks = () => {
    const [detailView, setDetailView] = useState(null)
    const [userTasks, setUserTasks] = useState(tasks)
    const [tasksSum, setTasksSum] = useState(0)

    const onClose = () => {
        setDetailView(null)
    }

    const filterTasks = (obj) => {
        const not_allowed = ["id", "updated", "user_id"]
        return Object.keys(obj)
            .filter((key) => !not_allowed.includes(key))
            .map((key) => ({ [key]: obj[key] }))
            .reduce((past, current) => {
                return { ...past, ...current }
            }, {})
    }

    const handleUserTasks = (key, status, value = 0) => {
        userTasks[key].completionStatus = status
        userTasks[key].value = value
        setUserTasks({ ...userTasks })
    }

    useEffect(() => {
        const getTasks = async () => {
            const data = await api.getUserTask()
            const items = data?.data
            if (items) {
                if (items.Count > 0) {
                    let result = filterTasks(items.Items[0])
                    // console.log("Result from filterTasks:", result)
                    for (const key of Object.keys(result)) {
                        if (parseInt(result[key].S) > 0) {
                            handleUserTasks(key, "Completed", parseInt(result[key].S))
                        } else {
                            handleUserTasks(key, "Not completed")
                        }
                    }
                    let sum = 0
                    for (const key of Object.keys(userTasks)) {
                        sum += parseInt(userTasks[key].value)
                        setTasksSum(sum)
                    }
                }
            }
        }
        getTasks()
    }, [])

    return (
        <React.Fragment>
            <div className="content tasks-page">
                <BreadCrumb items={["Tasks"]} />
                <Card>
                    <CardBody>
                        <CardTitle className="h3">Tasks - Amount: {tasksSum} CRED</CardTitle>
                        <Table className="align-middle mb-0 table-nowrap task-table">
                            <thead className="table-light">
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">CRED Value</th>
                                    <th scope="col">Completion Status</th>
                                    <th> </th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.keys(userTasks).map((key, i) => (
                                    <tr key={i}>
                                        <td>{userTasks[key].name}</td>
                                        <td>{userTasks[key].cred}</td>
                                        <td>{userTasks[key].completionStatus}</td>
                                        <td>
                                            <span className="btn--question" onClick={() => setDetailView(userTasks[key])}>
                                                <i className="bx bx-question-mark" />
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </div>
            <Modal className="task-detail-info-modal" isOpen={!!detailView} onClose={onClose} fade={true} centered={true}>
                <ModalHeader toggle={onClose} tag={"div"}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h5>Detail Info</h5>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <FormGroup className="mb-3">
                        <Label className="form-label">Name</Label>
                        <CardText>{detailView?.name}</CardText>
                    </FormGroup>
                    <FormGroup className="mb-3">
                        <Label className="form-label">CRED Value</Label>
                        <CardText>{detailView?.cred}</CardText>
                    </FormGroup>
                    <FormGroup className="mb-3">
                        <Label className="form-label">Requirements</Label>
                        <CardText>{detailView?.requirements}</CardText>
                    </FormGroup>
                    <FormGroup className="mb-3">
                        <Label className="form-label">Completion Status</Label>
                        <CardText>{detailView?.completionStatus}</CardText>
                    </FormGroup>
                    <div className="d-flex justify-content-end">
                        <Button color="primary" type="submit" className="save-contract-btn waves-effect" onClick={onClose}>
                            Close
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

export default Tasks
